/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { times } from 'lodash';

// CDS
import { Typography, breakpoints } from '@coursera/cds-core';

import TutorialHubCardPlaceholder from 'bundles/tutorials/components/PostCardPlaceholder';

import _t from 'i18n!nls/tutorials';

const styles = {
  hubPlaceholderContainer: css`
    max-width: 868px;
    width: 100%;
    margin: 0 auto;
  `,
  header: () => css`
    margin: var(--cds-spacing-600) var(--cds-spacing-800);
    padding: 0 var(--cds-spacing-150);
    ${breakpoints.down('xs')} {
      margin: var(--cds-spacing-600) 0;
    }
  `,
};

const TutorialHubPlaceholder = () => {
  return (
    <div className="rc-TutorialHubPlaceholder">
      <div css={styles.hubPlaceholderContainer}>
        <Typography variant="d2semibold" component="h1" css={styles.header}>
          {_t('Programming Tutorials')}
        </Typography>
        <div>
          {times(10, () => (
            <TutorialHubCardPlaceholder />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TutorialHubPlaceholder;
